import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=6442cd91&scoped=true"
import script from "./AddAdmin.vue?vue&type=script&lang=js"
export * from "./AddAdmin.vue?vue&type=script&lang=js"
import style0 from "./AddAdmin.vue?vue&type=style&index=0&id=6442cd91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6442cd91",
  null
  
)

export default component.exports